import { useEffect, useState } from 'react'
import Link from "next/link"
import Router from 'next/router'
import Image from 'next/image'
import { useUser } from "../../hooks/useUser"
import { random_string } from '../../functions/random/random'
import AnalyticsTrigger from '../../components/atoms/AnalyticsTrigger'
import Loading from '../../components/atoms/Loading'
import Layout from '../../components/templates/Layout'


export const Login = ({}) => {

  const [redirectUrl, setRedirectUrl] = useState<string>('')
  const [oauthState, setOauthState] = useState<string>('')
  const { user, authenticating } = useUser()

  useEffect(() => {
    let urlParamStr = ''
    setRedirectUrl(window.location.protocol + '//' + window.location.host + '/auth/oauth_complete')
    urlParamStr = window.location.search

    const next = urlParamStr.replace('?next=', '')
    localStorage.setItem('next_uri', next)
    const oauth_state = random_string()
    setOauthState(oauth_state)
    localStorage.setItem('oauth_state', oauth_state)
  }, [])

  if (user===null) {
    return (
      <Layout>
        <AnalyticsTrigger title={"ログインページ"} />
        <div style={{width: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
          <div style={{maxWidth: "400px"}}>
            <div style={{display: "flex"}}>
              <a href={process.env.NEXT_PUBLIC_BACKEND + 'auth/oauth/authorize/google/?state=' + oauthState + '&redirect_url=' + redirectUrl} className='google_oauth'>
                <span style={{display: "flex", transform: "scale(0.6)"}}>
                  <Image alt="google_logo" src={'/static/logos/google.svg'} width="48" height="48" className="p-8 mt-4"/>
                </span>
                <span>Googleでログイン</span>
              </a>
            </div>
            <div style={{display: "flex", justifyContent: "center", fontSize: ".8em"}}>
              <span>
                <Link href='/terms' prefetch={false}><a className="blue_link">利用規約</a></Link>、
                <Link href='/privacy' prefetch={false}><a className="blue_link">プライバシーポリシー</a></Link>
                に同意したうえでログインしてください。
              </span>
            </div>
          </div>
        </div>
      </Layout>
    )
  }

  if (user) {
    Router.replace('/auth/account')
  }

  return (<Loading />)
}

export default Login;
